import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
export { getKpiGoals } from './getKpiGoals'

export type KPIOption = {
  id: string
  target_fields: string[]
  target_models: string[]
  calculation: string
  description: string
  title: string
  area: string
}

export interface KPIGoal {
  id: number
  year: string
  quarter: string
  branch: string
  milestones: number[]
  kpi: string
}

export const getKPIOptions = async (): Promise<KPIOption[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/`)

    return response.data
  } catch (error) {
    console.error('Error fetching chart metrics:', error)
    throw error
  }
}

export const saveKPIGoals = async (kpiGoals: KPIGoal[]) => {
  try {
    const response = await axios.post(`${BASE_URL}/kpi-goal/`, {
      goals: kpiGoals,
    })
    return response.data
  } catch (error) {
    console.error('Error saving KPI goals:', error)
    throw error
  }
}

export const getKPIGoals = async (
  branchId?: string,
  quarter?: string,
  year?: string
) => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi-goal/`, {
      params: {
        branches: branchId,
        quarter: quarter === '-1' ? undefined : quarter,
        year: year,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching KPI goals:', error)
    throw error
  }
}

export const deleteKPIGoal = async (id: string) => {
  try {
    const response = await axios.delete(`${BASE_URL}/kpi-goal/?ids=${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting KPI goal:', error)
    throw error
  }
}
